export const getRecircLink = (recircLink) => {
  const prefixTable = {
    ContentfulArticleLongForm: recircLink.podcast ? '/podcast' : '/article',
    ContentfulFranchises: '',
    ContentfulStory: '/story',
    ContentfulTag: '/topic',
  };

  return `${prefixTable[recircLink.internal.type]}/${recircLink.slug}/`;
};
export const getRecircTitle = (recircLink) => {
  const titleTable = {
    ContentfulArticleLongForm: 'title',
    ContentfulFranchises: 'franchiseName',
    ContentfulStory: 'title',
    ContentfulTag: 'name',
  };
  return recircLink[titleTable[recircLink.internal.type]];
};
